import { defineMessages } from 'react-intl';

export const ProductSelectionSelectMessages = defineMessages({
  SelectVariation: {
    id: 'product.variationSelect.select.selectVariation',
    defaultMessage: 'Bitte wählen',
  },
  DialogHeadline: {
    id: 'product.variationSelect.select.dialog.headline',
    defaultMessage: 'Bitte {dimension} wählen',
  },
});
